import React from 'react';
import { IoShieldCheckmarkSharp, IoLocationSharp, IoHardwareChipSharp, IoLockClosedSharp, IoClose } from 'react-icons/io5';
import '../../App.css';

const PrivacyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay backdrop-blur" onClick={onClose}>
      <div className="modal-content privacy-modal-container" onClick={(e) => e.stopPropagation()}>
        
        {/* --- FIXED HEADER --- */}
        <div className="modal-header-bar">
          <div className="modal-header-title">
            <IoShieldCheckmarkSharp className="privacy-icon-glow" />
            <h3>Privacy Policy 🌑</h3>
          </div>
          <button className="modal-close-icon-btn" onClick={onClose} aria-label="Close modal">
            <IoClose />
          </button>
        </div>

        {/* --- SCROLLABLE BODY --- */}
        <div className="privacy-modal-scroll custom-scrollbar">
          <p className="privacy-intro">
            Night Lights is built as an anonymous sanctuary. We prioritize your physical and emotional privacy above all else.
          </p>

          <div className="divider-line"></div>

          {/* Section 1: Anonymous Sanctuary */}
          <div className="privacy-card">
            <div className="privacy-card-header">
              <IoLockClosedSharp className="privacy-card-icon cyan-icon" />
              <h4>1. 100% Anonymous Sanctuary</h4>
            </div>
            <p>
              We do not require user accounts, names, email addresses, phone numbers, or passwords. Your identity remains completely private.
            </p>
          </div>

          {/* Section 2: Location Fuzzing */}
          <div className="privacy-card highlight-card">
            <div className="privacy-card-header">
              <IoLocationSharp className="privacy-card-icon gold-icon" />
              <h4>2. Location Fuzzing Protection</h4>
            </div>
            <p>
              When you post a signal, your precise GPS coordinates are randomized with a ~1 km offset radius before saving. Your exact real-world location is never exposed or saved.
            </p>
          </div>

          {/* Section 3: On-Device Processing */}
          <div className="privacy-card">
            <div className="privacy-card-header">
              <IoHardwareChipSharp className="privacy-card-icon purple-icon" />
              <h4>3. On-Device & Safe Processing</h4>
            </div>
            <p>
              Message sentiment is analyzed on-device using local Google ML Kit capabilities when available. Messages are stored anonymously on the shared map without user tracking.
            </p>
          </div>

          {/* Section 4: Data Retention & Local Storage */}
          <div className="privacy-card">
            <div className="privacy-card-header">
              <IoShieldCheckmarkSharp className="privacy-card-icon pink-icon" />
              <h4>4. Data Retention & Preferences</h4>
            </div>
            <p>
              Local device storage is used exclusively to retain user preferences (e.g. mute state 🔊/🔇 and local resonance state). We do not use advertising cookies or sell user data.
            </p>
          </div>
        </div>

        {/* --- FIXED FOOTER --- */}
        <div className="privacy-modal-footer">
          <button onClick={onClose} className="btn-submit enter-btn">
            Got it
          </button>
        </div>

      </div>
    </div>
  );
};

export default PrivacyModal;
